const host = process.env.JIBJAB_API_HOST ? `https://${process.env.JIBJAB_API_HOST}` : "";

export default {
  rootPath: () => `${host}/v1`,
  invites: (slug) => (slug ? `${host}/v1/invites/${slug}` : `${host}/v1/invites`),
  inviteGuests: (slug) => `${host}/v1/invites/${slug}/guests`,
};
